'use client';

import { ReactNode } from 'react';

import { cn } from '@/utils/cn-tw-merge';

interface CartGroupCardProps {
  children: ReactNode;
  className?: string;
  dataTestId: string;
}

export function CartGroupCard({ children, className, dataTestId }: CartGroupCardProps) {
  return (
    <article
      className={cn(
        'flex flex-col rounded-lg border border-gray-300 bg-gray-50 p-4',
        className,
      )}
      data-testid={dataTestId}
    >
      {children}
    </article>
  );
}
